<template>
  <div>
    <ListCurrent></ListCurrent>
    <Failures class="mt-10"></Failures>
  </div>
</template>

<script>
import ListCurrent from './List-Current.vue';
import Failures from './Failures.vue';

export default {
  name: 'HomePage',
  components: {
    ListCurrent,
    Failures,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
